import { render, staticRenderFns } from "./MedicoesCubagem.vue?vue&type=template&id=58401fc2&scoped=true"
import script from "./MedicoesCubagem.vue?vue&type=script&lang=js"
export * from "./MedicoesCubagem.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=58401fc2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58401fc2",
  null
  
)

export default component.exports